module.exports = __webpack_public_path__ + "static/img/BT.1015c78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/BT.svg
// module id = l2mP
// module chunks = 2